module.exports = __webpack_public_path__ + "statics/img/cate3-7@2x.ce534f89.png";